"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
export default function OurTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const team = [];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          
          
        </div>

        <div ref={ref} className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {team.map((member, i) => <Card key={member.id} data-index={i} className={`hover-lift bg-light-background shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`}>
              
              <CardContent>
                
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}